var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.inclusive))]),_vm._v(" "),(!_vm.subfield)?_c('span',[_vm._v(_vm._s(_vm.field))]):_vm._e(),_vm._v(" "),(_vm.subfield)?_c('span',[_vm._v(_vm._s(_vm.subfield))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.operator))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }